import React from 'react';
import Seekbar from './Seekbar.react';
import PlayPauseButton from './PlayPauseButton.react';
import FullscreenButton from './FullscreenButton.react';
import VolumeToggle from './VolumeToggle.react';
import { lengthString } from '../utils';

const Timer = ({time}) => <div className='b-timer'>{lengthString(time)}</div>;

class PlayerDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      time: null
    };

    this.onSeek = this.onSeek.bind(this);
  }

  onSeek(e) {
    this.setState({
      time: e.time
    });
  }

  render() {
    if (!this.props.video) return null;

    var fullscreenToggle = null;
    if (!this.props.noFullscreen) {
      fullscreenToggle = (
        <FullscreenButton
          toggleFullscreen={this.props.toggleFullscreen}
          isFullscreen={this.props.isFullscreen} />
      );
    }

    var duration = null;
    if (typeof this.props.duration === 'number' && this.props.duration > 0) {
      duration = <Timer time={this.props.duration} />;
    }

    var seekbar = null;
    if (!this.props.video.isLive || this.props.video.timeshift) {
      seekbar = <Seekbar {...this.props} onChange={this.onSeek}/>;
    }

    // The core video library (bambuser-video-js) exposes the absolute broadcast
    // length in 'currentOffsetFromStart'. Use that when available. The iframeapi
    // (bambuser-player-js), on the other hand, returns the value of 'currentOffsetFromStart'
    // from the standard 'currentTime' getter when available. I.e. use 'currentTime'
    // if the 'currentOffsetFromStart' isn't available.
    let currentTime = typeof this.props.video.currentOffsetFromStart !== 'undefined'
      ? this.props.video.currentOffsetFromStart
      : this.props.video.currentTime;

    if (currentTime < 0) {
      if (this.props.video.isLive && !this.props.video.timeshift) {
        currentTime = null; // if live and currentOffsetFromStart < 0 then we don't have a timeline that shows the actual playback time from broadcast start
      } else {
        currentTime = this.props.video.currentTime;
      }
    }
    let time = this.state.time ? this.state.time : currentTime;
    return (
      <div className='b-dashboard'>
        <div className='b-contents'>
          <div>
            {(!this.props.video.isLive || this.props.timeshift) && <PlayPauseButton {...this.props} />}
            <VolumeToggle volume={this.props.volume * 100} video={this.props.video} />
            <Timer time={time} />
          </div>
          <div>
            {seekbar}
          </div>
          <div>
            {duration}
            {fullscreenToggle}
          </div>
        </div>
      </div>
    );
  }
}

export default PlayerDashboard;
